import React, { useState } from 'react';
import { useHistory } from 'react-router';
import RightArrow from '../../assets/images/left-arrow-symbol.svg';
import Header from '../../components/common/global-top-bar';
import { Spinner } from '../../components/common';
import { MemberTypes } from './common/member-constants';
import moment from 'moment';
import Searchbar from '../../components/common/searchbar';
import { sortArrow } from '../../assets/images';
import { convertObjectToParams } from '../../components/common/create-params';
import { ROUTE_PATH } from '../../routes/paths';
import { Paginator } from '../../components/common/paginator';
import { MemberPayload, useMemberCount, useMembers } from '../../hooks/useMembers';

const Members: React.FunctionComponent = (): JSX.Element => {
  const history = useHistory();
  const [filters, setFilters] = useState<MemberPayload>({
    page: 1,
    limit: 25,
    search: '',
    type: MemberTypes.ALL,
    order_by_direction: 'desc',
    order_by: 'date',
    is_active: undefined,
  });

  const { data: members, isLoading: membersLoading } = useMembers(filters);
  const { data: memberCount, isLoading: memberCountLoading } = useMemberCount(filters);

  const handleSort = (type: string) => {
    setFilters({
      ...filters,
      order_by: type,
      order_by_direction:
        filters.order_by === type ? (filters?.order_by_direction === 'desc' ? 'asc' : 'desc') : 'desc',
    });
  };

  return (
    <div>
      {(membersLoading || memberCountLoading) && <Spinner />}
      <Header heading={'Members'} />
      <Filters count={memberCount?.count} setFilters={setFilters} filters={filters} />
      <div className="max-window-height overflow-y-auto px-7">
        <table className="table-row-format relative mb-5 w-full table-fixed border-collapse text-xs">
          <thead className="h-full bg-white">
            <tr className="w-full px-7 text-left">
              <th
                className={`sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 ${
                  filters.order_by === 'name' && 'blue-primary'
                }`}
              >
                <div
                  className="flex items-center pl-1"
                  role="button"
                  onClick={() => {
                    handleSort('name');
                  }}
                >
                  Name{' '}
                  {filters.order_by === 'name' && (
                    <img
                      src={sortArrow}
                      className={`ml-2 h-4 w-4 cursor-pointer ${
                        filters?.order_by_direction === 'desc' ? `rotate-180 transform` : ``
                      }`}
                      alt="profile"
                    ></img>
                  )}
                </div>
              </th>
              <th
                className={`sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 ${
                  filters.order_by === 'plan_name' && 'blue-primary'
                }`}
              >
                <div
                  className="flex items-center"
                  role="button"
                  onClick={() => {
                    handleSort('plan_name');
                  }}
                >
                  Plan Name{' '}
                  {filters.order_by === 'plan_name' && (
                    <img
                      src={sortArrow}
                      className={`ml-2 h-4 w-4 cursor-pointer ${
                        filters?.order_by_direction === 'desc' ? `rotate-180 transform` : ``
                      }`}
                      alt="profile"
                    ></img>
                  )}
                </div>
              </th>
              <th
                className={`sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 ${
                  filters.order_by === 'plan_code' && 'blue-primary'
                }`}
              >
                <div
                  className="flex items-center"
                  role="button"
                  onClick={() => {
                    handleSort('plan_code');
                  }}
                >
                  Plan Code{' '}
                  {filters.order_by === 'plan_code' && (
                    <img
                      src={sortArrow}
                      className={`ml-2 h-4 w-4 cursor-pointer ${
                        filters?.order_by_direction === 'desc' ? `rotate-180 transform` : ``
                      }`}
                      alt="profile"
                    ></img>
                  )}
                </div>
              </th>
              <th className="sticky top-0 mb-4 h-full w-3/12 bg-white px-2 py-2">
                <p className="-pl-4">Activated At</p>
              </th>
              <th
                className={`sticky top-0 mb-4 h-full w-3/12 bg-white px-2 py-2 ${
                  filters.order_by === 'date' && 'blue-primary'
                }`}
              >
                <div
                  className="flex items-center"
                  role="button"
                  onClick={() => {
                    handleSort('date');
                  }}
                >
                  {' '}
                  Most Recent Engagement{' '}
                  {filters.order_by === 'date' && (
                    <img
                      src={sortArrow}
                      className={`ml-2 h-4 w-4 cursor-pointer ${
                        filters?.order_by_direction === 'desc' ? `rotate-180 transform` : ``
                      }`}
                      alt="profile"
                    ></img>
                  )}
                </div>
              </th>
              <th className="sticky top-0 mb-4 h-full w-1/12 bg-white px-2 py-2">
                <p className="-pl-4">Moods</p>
              </th>
              <th className="sticky top-0 mb-4 h-full w-1/12 bg-white px-2 py-2">
                <p className="pl-1">Plays</p>
              </th>
              <th className="sticky top-0 mb-4 h-full w-1/12 bg-white px-2 py-1">Calls</th>
              <th className="sticky top-0 z-10 mb-4 h-full w-2/12 bg-white px-2 py-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr className="h-2"></tr>
            {members &&
              members.length > 0 &&
              members.map((item: any) => {
                return (
                  <tr
                    role="button"
                    className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white bg-gray-200 text-left"
                    onClick={() => {
                      history.push(
                        ROUTE_PATH.MEMBERS_PROFILE +
                          convertObjectToParams({
                            name: item.first_name,
                            id: item.id,
                            callerRoleId: item.caller_role_id,
                          }),
                      );
                    }}
                  >
                    <td className="w-2/12 truncate py-1 pl-1">
                      <div className="flex flex-col">
                        <span className="truncate">{`${item.first_name} ${item.last_name}`}</span>
                        <span className="text-xs text-gray-500">{`#${item.id}`}</span>
                      </div>
                    </td>
                    <td className="w-2/12 truncate py-1">{`${item.plan_name}`}</td>
                    <td className="w-2/12 py-1">{`${item.plan_code}`}</td>
                    <td className="w-3/12 py-1">{`${
                      item.caller_role.onboarding_completed
                        ? `${moment(item.caller_role.onboarding_completed).local().format('MMM Do YYYY')} @ ${moment(
                            item.caller_role.onboarding_completed,
                          )
                            .local()
                            .format('HH:mm')}`
                        : '-'
                    }`}</td>
                    <td className={`w-3/12 py-1 ${!item.latest_engagement && 'pl-24 font-bold'}`}>
                      {' '}
                      {`${
                        item.latest_engagement
                          ? `${moment(item.latest_engagement).local().format('MMM Do YYYY')} @ ${moment(
                              item.latest_engagement,
                            )
                              .local()
                              .format('HH:mm')}`
                          : '-'
                      }`}
                    </td>
                    <td className="w-1/12 py-1">{item.moods_count} </td>
                    <td className="w-1/12 py-1">
                      <p className="pl-1"> {item.plays_count}</p>
                    </td>
                    <td className="w-1/12 py-1">{item.calls_count}</td>

                    <td className="w-2/12 px-2 py-1">
                      <div className="flex items-center justify-between">
                        <div className="w-2/3">
                          {item.calls_count > 0 ? (
                            <button className={'stacked-bar-green-primary rounded-full px-2 py-1 text-sm text-white'}>
                              Caller
                            </button>
                          ) : (
                            <p className="w-full text-center font-bold">-</p>
                          )}
                        </div>
                        <button className="blue-primary h-8 w-8 rotate-180 transform rounded-full">
                          <img className="h-8 w-8" src={RightArrow} alt="left Arrow"></img>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

type FilterProps = {
  count: number | undefined;
  setFilters: React.Dispatch<React.SetStateAction<MemberPayload>>;
  filters: MemberPayload;
};

const Filters: React.FunctionComponent<FilterProps> = ({ count, setFilters, filters }): JSX.Element => {
  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-between border-b px-7">
      <div className="w-1/4">
        <div className="h-8 w-full">
          <Searchbar
            search={(data) => {
              setFilters((prev: MemberPayload) => {
                return { ...prev, page: 1, search: data };
              });
            }}
          />
        </div>
      </div>
      <div className="w-3/4">
        <Paginator
          count={count!}
          limit={25}
          currentPage={filters.page}
          handlePageChange={(page) =>
            setFilters((filter: MemberPayload) => {
              return { ...filter, page: page };
            })
          }
        />
      </div>
      <div className="w-1/3">
        <div className="flex justify-end">
          <div className="gray-background-dark flex items-center justify-between py-4">
            {Object.keys(MemberTypes).map((item) => (
              <button
                className={
                  'px-5 py-1 text-sm ' +
                  //@ts-ignore
                  (MemberTypes[item as keyof typeof MemberTypes] === filters.type
                    ? 'bg-blue-primary text-white'
                    : 'bg-gray-background-dark text-gray-dark')
                }
                onClick={() => {
                  if (MemberTypes[item as keyof typeof MemberTypes] === MemberTypes.ACTIVE) {
                    setFilters((filter: MemberPayload) => {
                      return {
                        ...filter,
                        type: MemberTypes[item as keyof typeof MemberTypes],
                        is_active: true,
                        page: 1,
                      };
                    });
                  } else {
                    setFilters((filter: MemberPayload) => {
                      return {
                        ...filter,
                        type: MemberTypes[item as keyof typeof MemberTypes],
                        is_active: undefined,
                        page: 1,
                      };
                    });
                  }
                }}
              >
                {/* @ts-ignore */}
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Members;
